import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "support-categories" }
const _hoisted_2 = { class: "support-categories__cards-container" }
const _hoisted_3 = {
  key: 0,
  class: "support-categories__back-button-container"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon-chevron-left support-categories__back-icon" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SupportCategoriesCard = _resolveComponent("SupportCategoriesCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      ($setup.categoryStack.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goBack())),
              class: "support-categories__back-button"
            }, _toDisplayString($setup.translations?.GoBack), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentCategory, (category) => {
        return (_openBlock(), _createElementBlock("div", {
          key: category.Id,
          class: "support-categories-card support-categories-card--nav"
        }, [
          _createVNode(_component_SupportCategoriesCard, {
            sortOrder: category.SortOrder,
            displayTitle: category.DisplayTitle,
            imageUrl: category.CategoryCoverImageUrl,
            imageAlt: category.CategoryCoverImage,
            imageWidth: 70,
            childCategories: category.ChildCategories,
            onEnterCategory: $setup.enterCategory,
            currentCategory: $setup.currentCategory,
            urlName: category.UrlName,
            isNavVersion: true,
            baseUrl: $setup.translations.SupportDetailUrl
          }, null, 8 /* PROPS */, ["sortOrder", "displayTitle", "imageUrl", "imageAlt", "childCategories", "onEnterCategory", "currentCategory", "urlName", "baseUrl"])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}